module.exports = __webpack_public_path__ + "img/404.54154b1f.svg";